import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import React, { useState } from 'react';
import SvgEditImage from '../../../../__generated__/icon/SvgEditImage';
import { Button } from '../../../atom/Button/Button';
import { Checkbox } from '../../../atom/Checkbox/Checkbox';
import { Input } from '../../../atom/Input/Input';
import { InputDecorator } from '../../../atom/InputDecorator/InputDecorator';
import { Modal } from '../../../atom/Modal/Modal';
import { Radio } from '../../../atom/Radio/Radio';
import type { CustomImageOptions } from '../_utils/CustomImage';
interface ImageEditButtonProps {
  onClick: () => void;
  selectedOptions: CustomImageOptions | null;
  onSubmit: () => void;
  onWidthChange: (width: number | null) => void;
  onIsBorderRadiusChange: (isBorderRadius: boolean) => void;
  onAlignChange: (align: CustomImageOptions['align']) => void;
  disabled?: boolean;
}

/**
 * 에디터 툴바의 이미지 속성 수정 버튼
 */
export const ImageEditButton = t0 => {
  const $ = _c(41);
  const {
    onClick,
    selectedOptions,
    onSubmit,
    onWidthChange,
    onIsBorderRadiusChange,
    onAlignChange,
    disabled
  } = t0;
  const [isModalOpened, setIsModalOpened] = useState(false);
  let t1;
  if ($[0] !== onWidthChange) {
    t1 = event => {
      const inputValue = event.target.value;
      if (inputValue === "") {
        onWidthChange(null);
        return;
      }
      const numberValue = Number(inputValue);
      if (!Number.isNaN(numberValue)) {
        onWidthChange(numberValue);
      }
    };
    $[0] = onWidthChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleWidthChange = t1;
  let t2;
  if ($[2] !== disabled) {
    t2 = cn("flex size-24 items-center justify-center text-Gray-900", {
      "cursor-not-allowed text-Gray-400": disabled
    });
    $[2] = disabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClick) {
    t3 = () => {
      setIsModalOpened(true);
      onClick();
    };
    $[4] = onClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgEditImage className="size-20" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== disabled || $[8] !== t2 || $[9] !== t3) {
    t5 = <button aria-label={"\uC774\uBBF8\uC9C0 \uD3B8\uC9D1"} className={t2} disabled={disabled} type="button" onClick={t3}>{t4}</button>;
    $[7] = disabled;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsModalOpened(false);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = selectedOptions?.maxWidth ?? "";
  let t8;
  if ($[12] !== handleWidthChange || $[13] !== t7) {
    t8 = <InputDecorator label={"\uAC00\uB85C(px)"}><Input value={t7} onChange={handleWidthChange} /></InputDecorator>;
    $[12] = handleWidthChange;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <InputDecorator label={"\uC138\uB85C(px)"}><p>세로 사이즈는 비율에 따라 자동으로 조절됩니다.</p></InputDecorator>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = selectedOptions?.isBorderRadius;
  let t11;
  if ($[16] !== onIsBorderRadiusChange || $[17] !== t10) {
    t11 = <InputDecorator label="Image Radius"><Checkbox checked={t10} onCheckedChange={onIsBorderRadiusChange} /></InputDecorator>;
    $[16] = onIsBorderRadiusChange;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = selectedOptions?.align;
  let t13;
  let t14;
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Radio.Item value="left">왼쪽</Radio.Item>;
    t14 = <Radio.Item value="center">가운데</Radio.Item>;
    t15 = <Radio.Item value="right">오른쪽</Radio.Item>;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t13 = $[19];
    t14 = $[20];
    t15 = $[21];
  }
  let t16;
  if ($[22] !== onAlignChange || $[23] !== t12) {
    t16 = <InputDecorator label={"\uC815\uB82C"}><Radio.Group value={t12} onChange={onAlignChange}>{t13}{t14}{t15}</Radio.Group></InputDecorator>;
    $[22] = onAlignChange;
    $[23] = t12;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t11 || $[26] !== t16 || $[27] !== t8) {
    t17 = <article className="mb-32 flex flex-col gap-16">{t8}{t9}{t11}{t16}</article>;
    $[25] = t11;
    $[26] = t16;
    $[27] = t8;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== onSubmit) {
    t18 = <Button className="flex-1" onClick={() => {
      setIsModalOpened(false);
      onSubmit();
    }}>설정</Button>;
    $[29] = onSubmit;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Button className="flex-1" theme="sub-fill" onClick={() => {
      setIsModalOpened(false);
    }}>취소</Button>;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t18) {
    t20 = <footer className="flex w-full gap-8">{t18}{t19}</footer>;
    $[32] = t18;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== isModalOpened || $[35] !== t17 || $[36] !== t20) {
    t21 = <Modal opened={isModalOpened} onClose={t6}>{t17}{t20}</Modal>;
    $[34] = isModalOpened;
    $[35] = t17;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t21 || $[39] !== t5) {
    t22 = <>{t5}{t21}</>;
    $[38] = t21;
    $[39] = t5;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  return t22;
};